import {useEffect} from 'react';
import type {Pageable} from '@deviceinsight/ng-ui-api-client';
import {searchRules} from '../../../api/ruleApi';
import type {Rule} from '../../../modules/ruleengine/types';
import type {SearchSettings} from '../ruleListeHelpers';

const useSearchRules = (
	setIsLoading: (arg0: boolean) => void,
	searchSettings: SearchSettings,
	assetGroupId: number,
	setRules: (arg0: Pageable<Rule>) => void,
	setRuleToDelete: (arg0: Rule | null | undefined) => void,
	setRuleToUpdate: (arg0: Rule | null | undefined) => void
) => {
	useEffect(() => {
		setIsLoading(true);
		searchRules(searchSettings, assetGroupId).then((rules) => {
			setRuleToDelete(undefined);
			setRuleToUpdate(undefined);
			setRules(rules);
			setIsLoading(false);
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchSettings]);
};

export default useSearchRules;
